module.exports = __webpack_public_path__ + "static/media/tdm.ea866532.png";